import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
let galleryEnabled = false;
let galleryOverlay = null;
let currentIndex = 0;
let galleryItems = [];
let touchStartX = 0;
let touchStartY = 0;
export function isSouqDiscussion(discussion) {
  if (!discussion || typeof discussion.tags !== 'function') {
    return false;
  }
  return (discussion.tags() || []).some(tag => {
    return tag && typeof tag.slug === 'function' && tag.slug() === 'souq';
  });
}
function getGalleryItems() {
  const postBody = document.querySelector('.PostStream-item:first-child .Post-body');
  if (!postBody) {
    return [];
  }
  return Array.from(postBody.querySelectorAll('img')).filter(img => {
    const className = String(img.className || '').toLowerCase();
    const src = String(img.currentSrc || img.src || '').toLowerCase();

    /*
     * Flarum/emoji extensions may render
     * emoji characters as <img> elements.
     * They are not Souq listing photos.
     */
    if (className.includes('emoji') || src.includes('twemoji') || src.includes('/emoji/')) {
      return false;
    }

    /*
     * Exclude tiny decorative images/icons.
     */
    if (img.naturalWidth && img.naturalHeight && img.naturalWidth <= 128 && img.naturalHeight <= 128) {
      return false;
    }
    return true;
  }).map(img => {
    const link = img.closest('a');
    return {
      img,
      src: link && link.href || img.currentSrc || img.src,
      alt: img.alt || 'Souq listing photo'
    };
  }).filter(item => item.src);
}
function restoreNormalDiscussionControls() {
  document.querySelectorAll('.SouqHideNormalDiscussionControl').forEach(element => {
    element.classList.remove('SouqHideNormalDiscussionControl');
  });
  document.body.classList.remove('PinoyTalksSouqDiscussion');
}
function cleanupSouqDiscussionControls() {
  if (!galleryEnabled) {
    return;
  }
  const page = document.querySelector('.DiscussionPage') || document.querySelector('#content');
  if (!page) {
    return;
  }

  /*
   * -----------------------------------------
   * FOLLOW / SUBSCRIPTION
   * -----------------------------------------
   */
  page.querySelectorAll('.SubscriptionMenu, .SubscriptionButton').forEach(element => {
    const wrapper = element.closest('li') || element.closest('.ButtonGroup') || element;
    wrapper.classList.add('SouqHideNormalDiscussionControl');
  });

  /*
   * -----------------------------------------
   * GLOBAL WHATSAPP SHARE CONTROL
   * -----------------------------------------
   *
   * We deliberately exclude the Souq-specific
   * WhatsApp Seller button.
   */
  page.querySelectorAll('a, button').forEach(element => {
    if (element.closest('.SouqWhatsAppButton, .SouqWhatsAppOwner')) {
      return;
    }

    /*
     * Never touch the PinoyTalks Blog
     * article share bar.
     */
    if (element.closest('.PinoyTalksArticleShareBar')) {
      return;
    }
    const text = String(element.textContent || '').trim().toLowerCase();
    const href = String(element.getAttribute('href') || '').toLowerCase();
    const isWhatsApp = text === 'whatsapp' || text.startsWith('whatsapp ') || href.includes('wa.me/') || href.includes('whatsapp.com/');
    if (!isWhatsApp) {
      return;
    }

    /*
     * Flarum controls are often wrapped
     * in <li>, Dropdown, or ButtonGroup.
     */
    const wrapper = element.closest('li') || element.closest('.Dropdown') || element.closest('.ButtonGroup') || element;
    wrapper.classList.add('SouqHideNormalDiscussionControl');
  });
}
let currentSouqDiscussion = null;
function souqDiscussionHasTag(discussion, slug) {
  if (!discussion || typeof discussion.tags !== 'function') {
    return false;
  }
  return (discussion.tags() || []).some(tag => {
    return tag && typeof tag.slug === 'function' && tag.slug() === slug;
  });
}
function isSouqOwnListing(discussion) {
  const actor = app.session.user;
  const seller = discussion && typeof discussion.user === 'function' ? discussion.user() : null;
  if (!actor || !seller) {
    return false;
  }
  return String(actor.id()) === String(seller.id());
}
function removeSouqDetailContactBar() {
  document.querySelectorAll('.SouqDetailContactBar').forEach(element => {
    element.remove();
  });
}
function contactSouqSellerFromDetail(discussion) {
  const seller = discussion.user ? discussion.user() : null;
  if (!seller) {
    app.alerts.show({
      type: 'error'
    }, 'Seller information is unavailable.');
    return;
  }

  /*
   * Same login behavior used by
   * the Souq listing cards.
   */
  if (!app.session.user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return;
  }
  if (isSouqOwnListing(discussion)) {
    return;
  }
  const sellerName = seller.displayName ? seller.displayName() : 'Seller';
  const listingTitle = discussion.title ? discussion.title() : 'Souq listing';
  const shortTitle = listingTitle.length > 80 ? listingTitle.slice(0, 77) + '...' : listingTitle;
  const discussionPath = app.route.discussion(discussion);
  const listingUrl = window.location.origin + discussionPath;
  const message = `Hi ${sellerName},

I'm interested in your listing:

${listingTitle}

Is this still available?

View listing:
${listingUrl}`;
  const query = '?recipientUsers=' + encodeURIComponent(String(seller.id())) + '&title=' + encodeURIComponent('Souq inquiry: ' + shortTitle) + '&content=' + encodeURIComponent(message) + '&redirect=' + encodeURIComponent(discussionPath);
  m.route.set('/private/composer' + query);
}
function openSouqWhatsAppFromDetail(discussion) {
  if (!app.session.user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return;
  }
  const url = app.forum.attribute('apiUrl') + '/souq/contact/' + discussion.id() + '/whatsapp';
  window.open(url, '_blank', 'noopener,noreferrer');
}
async function getSouqDetailContactState(discussion) {
  const id = String(discussion.id());
  const state = {
    sold: souqDiscussionHasTag(discussion, 'souq-sold'),
    expired: false,
    whatsappAvailable: false
  };

  /*
   * WhatsApp availability already
   * respects seller opt-in, SOLD and
   * EXPIRED status on the backend.
   */
  try {
    const contactResponse = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/souq/contact-availability?ids=' + encodeURIComponent(id)
    });
    state.whatsappAvailable = Boolean(contactResponse && contactResponse.data && contactResponse.data[id] && contactResponse.data[id].whatsappAvailable);
  } catch (error) {
    console.warn('Souq detail WhatsApp availability failed:', error);
  }

  /*
   * Check expiry separately so normal
   * Contact Seller is also disabled
   * for expired listings.
   */
  try {
    const expiryResponse = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/souq/expiries?ids=' + encodeURIComponent(id)
    });
    const root = expiryResponse && expiryResponse.data ? expiryResponse.data : {};
    const meta = root[id] || root.data && root.data[id] || null;
    if (meta) {
      if (meta.expired === true || meta.isExpired === true) {
        state.expired = true;
      }
      const expiresAt = meta.expiresAt || meta.expires_at || null;
      if (expiresAt && !Number.isNaN(new Date(expiresAt).getTime()) && new Date(expiresAt).getTime() <= Date.now()) {
        state.expired = true;
      }
    }
  } catch (error) {
    console.warn('Souq detail expiry check failed:', error);
  }
  return state;
}
async function renderSouqDetailContactBar(discussion) {
  if (!galleryEnabled || !discussion || currentSouqDiscussion !== discussion) {
    return;
  }

  /*
   * Seller should never see buyer
   * contact controls on own listing.
   */
  if (isSouqOwnListing(discussion)) {
    removeSouqDetailContactBar();
    return;
  }
  const postBody = document.querySelector('.PostStream-item:first-child .Post-body');
  if (!postBody) {
    return;
  }
  if (document.querySelector('.SouqDetailContactBar')) return;
  const state = await getSouqDetailContactState(discussion);

  /*
   * Prevent an old async request from
   * inserting controls after navigation.
   */
  if (!galleryEnabled || currentSouqDiscussion !== discussion) {
    return;
  }
  if (document.querySelector('.SouqDetailContactBar')) return;
  const bar = document.createElement('section');
  bar.className = 'SouqDetailContactBar';

  /*
   * SOLD / EXPIRED listings remain
   * visible but cannot be contacted.
   */
  if (state.sold || state.expired) {
    bar.innerHTML = `
            <div class="SouqDetailContactBar-copy">
                <strong>
                    ${state.sold ? 'Item Sold' : 'Listing Expired'}
                </strong>

                <small>
                    Seller contact is unavailable
                    for this listing.
                </small>
            </div>

            <button
                type="button"
                class="SouqDetailContactBar-disabled"
                disabled
            >
                ${state.sold ? '✓ ITEM SOLD' : '⌛ LISTING EXPIRED'}
            </button>
        `;
    postBody.appendChild(bar);
    return;
  }
  bar.innerHTML = `
        <div class="SouqDetailContactBar-copy">
            <strong>
                Interested in this item?
            </strong>

            <small>
                Contact the seller privately.
            </small>
        </div>

        <button type="button" class="SouqDetailContactToggle SouqDetailMessageSeller"
            aria-expanded="false" aria-controls="SouqDetailContactMethods">
            Contact Seller
        </button>
        <div id="SouqDetailContactMethods" class="SouqDetailContactBar-actions" hidden>

            <button
                type="button"
                class="SouqDetailMessageMethod"
            >
                Message Seller
            </button>

            ${state.whatsappAvailable ? `
                        <button
                            type="button"
                            class="SouqDetailWhatsAppSeller"
                        >
                            WhatsApp
                        </button>
                    ` : ''}

        </div>
    `;
  postBody.insertAdjacentElement('afterend', bar);
  bar.querySelector('.SouqDetailContactToggle').addEventListener('click', event => {
    const button = event.currentTarget;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    bar.querySelector('.SouqDetailContactBar-actions').hidden = expanded;
  });
  bar.querySelector('.SouqDetailMessageMethod')?.addEventListener('click', () => {
    contactSouqSellerFromDetail(discussion);
  });
  bar.querySelector('.SouqDetailWhatsAppSeller')?.addEventListener('click', () => {
    openSouqWhatsAppFromDetail(discussion);
  });
}
function closeGallery() {
  if (galleryOverlay) {
    galleryOverlay.remove();
    galleryOverlay = null;
  }
  document.body.classList.remove('SouqGallery-isOpen');
  document.removeEventListener('keydown', handleKeyboard);
}
function showImage(index) {
  if (!galleryOverlay || !galleryItems.length) {
    return;
  }
  if (index < 0) {
    index = galleryItems.length - 1;
  }
  if (index >= galleryItems.length) {
    index = 0;
  }
  currentIndex = index;
  const image = galleryOverlay.querySelector('.SouqGallery-image');
  const counter = galleryOverlay.querySelector('.SouqGallery-counter');
  if (image) {
    image.src = galleryItems[currentIndex].src;
    image.alt = galleryItems[currentIndex].alt;
  }
  if (counter) {
    counter.textContent = currentIndex + 1 + ' / ' + galleryItems.length;
  }
  galleryOverlay.classList.toggle('SouqGallery--single', galleryItems.length <= 1);
}
function previousImage() {
  showImage(currentIndex - 1);
}
function nextImage() {
  showImage(currentIndex + 1);
}
function handleKeyboard(event) {
  if (!galleryOverlay) {
    return;
  }
  if (event.key === 'Escape') {
    closeGallery();
    return;
  }
  if (event.key === 'ArrowLeft') {
    previousImage();
    return;
  }
  if (event.key === 'ArrowRight') {
    nextImage();
  }
}
function openGallery(clickedImage) {
  galleryItems = getGalleryItems();
  if (!galleryItems.length) {
    return;
  }
  const foundIndex = galleryItems.findIndex(item => item.img === clickedImage);
  currentIndex = foundIndex >= 0 ? foundIndex : 0;
  closeGallery();
  const overlay = document.createElement('div');
  overlay.className = 'SouqGallery';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Souq listing photos');
  overlay.innerHTML = `
        <button
            type="button"
            class="SouqGallery-close"
            aria-label="Close photo gallery"
        >
            ×
        </button>

        <div class="SouqGallery-counter"></div>

        <button
            type="button"
            class="SouqGallery-arrow SouqGallery-arrow--prev"
            aria-label="Previous photo"
        >
            ‹
        </button>

        <div class="SouqGallery-stage">
            <img
                class="SouqGallery-image"
                alt="Souq listing photo"
            />
        </div>

        <button
            type="button"
            class="SouqGallery-arrow SouqGallery-arrow--next"
            aria-label="Next photo"
        >
            ›
        </button>

        <div class="SouqGallery-mobileHint">
            Swipe left or right
        </div>
    `;
  document.body.appendChild(overlay);
  galleryOverlay = overlay;
  document.body.classList.add('SouqGallery-isOpen');
  overlay.querySelector('.SouqGallery-close')?.addEventListener('click', closeGallery);
  overlay.querySelector('.SouqGallery-arrow--prev')?.addEventListener('click', event => {
    event.stopPropagation();
    previousImage();
  });
  overlay.querySelector('.SouqGallery-arrow--next')?.addEventListener('click', event => {
    event.stopPropagation();
    nextImage();
  });
  overlay.addEventListener('click', event => {
    if (event.target === overlay) {
      closeGallery();
    }
  });
  const stage = overlay.querySelector('.SouqGallery-stage');
  stage?.addEventListener('touchstart', event => {
    const touch = event.changedTouches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
  }, {
    passive: true
  });
  stage?.addEventListener('touchend', event => {
    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - touchStartX;
    const deltaY = touch.clientY - touchStartY;

    /*
     * Require a meaningful horizontal
     * swipe and ignore vertical scrolling.
     */
    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }
    if (deltaX < 0) {
      nextImage();
    } else {
      previousImage();
    }
  }, {
    passive: true
  });
  document.addEventListener('keydown', handleKeyboard);
  showImage(currentIndex);
}

/*
 * Intercept clicks on listing images only while
 * viewing a Souq discussion.
 */
document.addEventListener('click', event => {
  if (!galleryEnabled) {
    return;
  }
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }
  const image = target.closest('.PostStream-item:first-child .Post-body img');
  if (!image) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }
  openGallery(image);
}, true);
extend(DiscussionPage.prototype, 'show', function (_returnedValue, discussion) {
  galleryEnabled = isSouqDiscussion(discussion);
  if (galleryEnabled) {
    currentSouqDiscussion = discussion;
    document.body.classList.add('PinoyTalksSouqDiscussion');

    /*
     * The first post may render shortly
     * after DiscussionPage.show().
     */
    setTimeout(() => renderSouqDetailContactBar(discussion), 100);
    setTimeout(() => renderSouqDetailContactBar(discussion), 500);
    setTimeout(() => renderSouqDetailContactBar(discussion), 1200);
  } else {
    currentSouqDiscussion = null;
    removeSouqDetailContactBar();
    restoreNormalDiscussionControls();
  }
  if (galleryEnabled) {
    /*
     * Flarum may render discussion controls
     * slightly after DiscussionPage.show().
     */
    setTimeout(cleanupSouqDiscussionControls, 50);
    setTimeout(cleanupSouqDiscussionControls, 300);
    setTimeout(cleanupSouqDiscussionControls, 900);
  }
  if (!galleryEnabled) {
    closeGallery();
  }
});
extend(DiscussionPage.prototype, 'onremove', function () {
  galleryEnabled = false;
  currentSouqDiscussion = null;
  removeSouqDetailContactBar();
  restoreNormalDiscussionControls();
  closeGallery();
});